/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
export type VideoEvent = {
  startWatchVideoTime: number | undefined;
  endWatchVideoTime: number | undefined;
  captureEventType: VideoEventType | undefined;
  startVideoRecordingTime: number | undefined;
  endVideoRecordingTime: number | undefined;
};

export enum VideoEventType {
  Pause,
  Unpause, // unused
  StartScrub,
  EndScrub,
  Play,
}
